// Local translations
export const T = {
  en_GB: {
    noteLabel: "Note:",
    backgroundPreview: "Background preview",
    logoPreview: "Logo preview",
    // Dialog titles
    sectionSettings: "Section Settings",
    addNewSection: "Add New Section",
    templateSettingsDescription: "Configure the section settings below",
    createSectionDescription: "Set up the basic properties for this section",
    // Form fields
    sectionName: "Section Name",
    sectionNamePlaceholder: "e.g., Cover Page, Portfolio Summary",
    sectionScope: "Section Scope",
    globalScopeOption: "Global (rendered once)",
    perGoalScopeOptionMulti: "Per Goal (rendered for each goal)",
    perGoalScopeOptionSingle: "Per Goal (rendered for the single goal)",
    globalScopeDescription:
      "This section will appear once in the PDF, typically used for cover pages, summaries, or terms.",
    perGoalScopeDescriptionMulti:
      "This section will be repeated for each investment goal in the flow.",
    perGoalScopeDescriptionSingle:
      "This section will contain goal-specific data for the single investment goal.",
    perGoalSingleNote:
      "Since this flow has only one goal, the per-goal section will be rendered once but will have access to goal-specific data.",
    perPortfolioScopeOption: "Per Portfolio (rendered for each portfolio)",
    perPortfolioScopeDescription:
      "This section will be repeated for each portfolio of every goal, with access to that portfolio's schedule, holdings, and analytics.",
    perPortfolio: "Per Portfolio",
    global: "Global",
    perGoal: "Per Goal",
    // Tabs
    page: "Page",
    orientation: "Orientation",
    portrait: "Portrait",
    landscape: "Landscape",
    orientationHelp:
      "Applies to every page this section produces. A section always starts on a new page, so a landscape section can sit between portrait sections in the same document.",
    background: "Background",
    header: "Header",
    footer: "Footer",
    // Background options
    noneWhite: "None (white)",
    color: "Color",
    image: "Image",
    backgroundColor: "Background Color",
    backgroundImage: "Background Image",
    backgroundImageDescription:
      "Upload an image (PNG, JPG) or PDF to use as a page background. The image will be scaled to fit the page.",
    imageUploaded: "Image uploaded",
    // Header options
    textLabel: "Text",
    insertField: "Insert Field",
    quizFields: "Quiz Results",
    quizOverrideFields: "Quiz overrides",
    quizExternalFields: "Quiz external results",
    client: "Client",
    customFields: "Custom Fields",
    ownerLabel: "Owner Fields",
    goalLabel: "Goal",
    flowFieldsLabel: "Flow Fields",
    flowLabel: "Flow",
    documentLabel: "Document",
    headerTextPlaceholder: "e.g., Investment Proposal for {{Client.Name}}",
    left: "Left",
    center: "Center",
    right: "Right",
    logo: "Logo",
    logoFileDescription:
      "Upload SVG, PNG, or JPG (max 2MB). Logo will be displayed at 40px height.",
    showLineBelowHeader: "Show line below header",
    // Footer options
    showPageNumbers: "Show page numbers",
    pageNumberPlacement: "Page number placement",
    showLineAboveFooter: "Show line above footer",
    // Actions
    cancel: "Cancel",
    save: "Save",
    addSection: "Add Section",
    remove: "Remove",
    // Messages
    sectionCreatedSuccess: "Section added",
    sectionUpdatedSuccess: "Saved",
    error: "Error",
    failedToSave: "Failed to save section",
    unexpectedError: "An unexpected error occurred",
    validationSectionNameRequired: "Section name is required",
    // File validation
    invalidFileType: "Invalid file type",
    supportedFormatsImage: "Supported formats: PNG, JPG, PDF",
    supportedFormatsLogo: "Supported formats: SVG, PNG, JPG",
    fileTooLarge: "File too large",
    maxFileSize: "Maximum file size is 5MB",
    maxLogoSize: "Maximum logo size is 2MB",
  },
  nb_NO: {
    noteLabel: "Merk:",
    backgroundPreview: "Forhåndsvisning av bakgrunn",
    logoPreview: "Forhåndsvisning av logo",
    // Dialog titles
    sectionSettings: "Seksjonsinnstillinger",
    addNewSection: "Legg til ny seksjon",
    templateSettingsDescription: "Konfigurer seksjonsinnstillingene nedenfor",
    createSectionDescription: "Sett opp de grunnleggende egenskapene for denne seksjonen",
    // Form fields
    sectionName: "Seksjonsnavn",
    sectionNamePlaceholder: "f.eks. Forside, Porteføljesammendrag",
    sectionScope: "Seksjonsomfang",
    globalScopeOption: "Global (vises én gang)",
    perGoalScopeOptionMulti: "Per mål (vises for hvert mål)",
    perGoalScopeOptionSingle: "Per mål (vises for det ene målet)",
    globalScopeDescription:
      "Denne seksjonen vises én gang i PDF-en, vanligvis brukt for forsider, sammendrag eller vilkår.",
    perGoalScopeDescriptionMulti: "Denne seksjonen gjentas for hvert investeringsmål i flyten.",
    perGoalScopeDescriptionSingle:
      "Denne seksjonen inneholder målspesifikke data for det ene investeringsmålet.",
    perGoalSingleNote:
      "Siden denne flyten bare har ett mål, vil per-mål-seksjonen vises én gang, men vil ha tilgang til målspesifikke data.",
    perPortfolioScopeOption: "Per portefølje (vises for hver portefølje)",
    perPortfolioScopeDescription:
      "Denne seksjonen gjentas for hver portefølje i hvert mål, med tilgang til porteføljens plan, beholdning og analyser.",
    perPortfolio: "Per portefølje",
    global: "Global",
    perGoal: "Per mål",
    // Tabs
    page: "Side",
    orientation: "Retning",
    portrait: "Stående",
    landscape: "Liggende",
    orientationHelp:
      "Gjelder alle sidene denne seksjonen lager. En seksjon starter alltid på en ny side, så en liggende seksjon kan stå mellom stående seksjoner i samme dokument.",
    background: "Bakgrunn",
    header: "Topptekst",
    footer: "Bunntekst",
    // Background options
    noneWhite: "Ingen (hvit)",
    color: "Farge",
    image: "Bilde",
    backgroundColor: "Bakgrunnsfarge",
    backgroundImage: "Bakgrunnsbilde",
    backgroundImageDescription:
      "Last opp et bilde (PNG, JPG) eller PDF for å bruke som sidebakgrunn. Bildet skaleres til å passe siden.",
    imageUploaded: "Bilde lastet opp",
    // Header options
    textLabel: "Tekst",
    insertField: "Sett inn felt",
    quizFields: "Quizresultater",
    quizOverrideFields: "Quiz-overstyringer",
    quizExternalFields: "Eksterne quiz-resultater",
    client: "Kunde",
    customFields: "Egendefinerte felt",
    ownerLabel: "Eierfelt",
    goalLabel: "Mål",
    flowFieldsLabel: "Flytfelt",
    flowLabel: "Flyt",
    documentLabel: "Dokument",
    headerTextPlaceholder: "f.eks. Investeringsforslag for {{Client.Name}}",
    left: "Venstre",
    center: "Midtstilt",
    right: "Høyre",
    logo: "Logo",
    logoFileDescription: "Last opp SVG, PNG eller JPG (maks 2MB). Logoen vises med 40px høyde.",
    showLineBelowHeader: "Vis linje under topptekst",
    // Footer options
    showPageNumbers: "Vis sidetall",
    pageNumberPlacement: "Plassering av sidetall",
    showLineAboveFooter: "Vis linje over bunntekst",
    // Actions
    cancel: "Avbryt",
    save: "Lagre",
    addSection: "Legg til seksjon",
    remove: "Fjern",
    // Messages
    sectionCreatedSuccess: "Seksjon lagt til",
    sectionUpdatedSuccess: "Lagret",
    error: "Feil",
    failedToSave: "Kunne ikke lagre seksjon",
    unexpectedError: "En uventet feil oppstod",
    validationSectionNameRequired: "Seksjonsnavn er påkrevd",
    // File validation
    invalidFileType: "Ugyldig filtype",
    supportedFormatsImage: "Støttede formater: PNG, JPG, PDF",
    supportedFormatsLogo: "Støttede formater: SVG, PNG, JPG",
    fileTooLarge: "Filen er for stor",
    maxFileSize: "Maksimal filstørrelse er 5MB",
    maxLogoSize: "Maksimal logostørrelse er 2MB",
  },
} as const;
